import {useEffect} from 'react';
import {fetchIssueInstanceAction} from '../app/actions';
import {viewTypes} from '../constants/view-types';

const ISSUE_UPDATED = 'ISSUE_UPDATED';

export const issueUpdatedMessageToParent = (viewType, issueId) => {
  if (viewType === viewTypes.DOCUMENT && window.parent !== window) {
    try {
      window.parent.postMessage({actionType: ISSUE_UPDATED, issueId}, '*');
      // eslint-disable-next-line no-empty
    } catch {}
  }
};

export const useRefetchIssueOnChangeFromIframe = (issue, dispatch) => {
  useEffect(() => {
    // handle update message from document iframe if any change is made there
    const handleMessage = event => {
      if (event.data?.actionType === ISSUE_UPDATED && issue?.id && issue.id === event.data.issueId) {
        dispatch(fetchIssueInstanceAction(issue.id));
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [issue, dispatch]);
};
